import React from 'react';
import ReactDOM from 'react-dom';
import store from './store/index';

// Support IE11
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import App from './App';
import * as serviceWorker from './serviceWorker';

import 'bootstrap/dist/css/bootstrap.css';
import './lib/css/index.css';

ReactDOM.render(
  <App store={store}/>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
